"use strict";
const COOKIE_STORAGE = "cookie";
const LOCAL_STORAGE = "persist";
const SESSION_STORAGE = "session";
const STATE_MANAGEMENT = "state";
const STATE_MANAGEMENT_API_HOST = "https://www.homedepot.com";
const EXPIRE_DAY = "day";
const EXPIRE_MONTH = "month";
const EXPIRE_YEAR = "year";
const encodeStorage = (value) => encodeURIComponent(value).replace(/\(/g, "%28").replace(/\)/g, "%29");
const decodeStorage = (value) => {
  const decodedValue = decodeURIComponent(value);
  return decodedValue;
};
const getOneDayFromNow = () => new Date(Date.now() + 24 * 60 * 60 * 1e3);
const getOneMonthFromNow = () => new Date(Date.now() + 30 * 24 * 60 * 60 * 1e3);
const getOneYearFromNow = () => new Date(Date.now() + 365 * 24 * 60 * 60 * 1e3);
const getCookieString = ({
  key,
  value,
  expires,
  path,
  domain
}) => `${key}=${encodeStorage(value)}; expires=${expires}; path=${path}; domain=${domain}`;
const getExpirationDate = (expiration) => {
  let expirationDate = /* @__PURE__ */ new Date();
  if (typeof expiration === "string") {
    switch (expiration) {
      case "day":
        expirationDate = getOneDayFromNow();
        break;
      case "month":
        expirationDate = getOneMonthFromNow();
        break;
      case "year":
      default:
        expirationDate = getOneYearFromNow();
        break;
    }
  } else if (typeof expiration === "number") {
    expirationDate = new Date(expirationDate.getTime() + expiration);
  } else {
    throw new Error("'ttl' must be a number or oneOf ['day', 'month', 'year']");
  }
  return expirationDate.toUTCString();
};
const setWebStorage = ({
  accessType,
  key,
  value,
  ttl,
  expiration: expirationProp = "year"
}) => {
  const expiration = ttl || expirationProp;
  if (typeof window !== "undefined") {
    const expirationDate = getExpirationDate(expiration);
    const item = JSON.stringify({
      value,
      expiry: expirationDate
    });
    const encodedItem = encodeStorage(item);
    if (accessType === LOCAL_STORAGE) {
      window.localStorage.setItem(key, encodedItem);
    } else if (accessType === SESSION_STORAGE) {
      window.sessionStorage.setItem(key, encodedItem);
    }
  }
};
const removeWebStorage = ({ accessType, key }) => {
  if (typeof window !== "undefined") {
    if (accessType === LOCAL_STORAGE) {
      window.localStorage.removeItem(key);
    } else if (accessType === SESSION_STORAGE) {
      window.sessionStorage.removeItem(key);
    }
  }
};
const getWebStorage = ({ accessType, key, returnString = true }) => {
  let storageValue;
  if (typeof window !== "undefined") {
    if (accessType === LOCAL_STORAGE) {
      storageValue = window.localStorage.getItem(key);
    } else if (accessType === SESSION_STORAGE) {
      storageValue = window.sessionStorage.getItem(key);
    }
  }
  let parsedValue;
  if (storageValue !== null) {
    try {
      const decodedValue = decodeStorage(storageValue);
      parsedValue = JSON.parse(decodedValue);
    } catch (e) {
      parsedValue = null;
    }
  } else {
    parsedValue = null;
  }
  if (new Date(parsedValue == null ? void 0 : parsedValue.expiry) <= Date.now()) {
    parsedValue = null;
    removeWebStorage({ accessType, key });
  }
  const result = parsedValue == null ? void 0 : parsedValue.value;
  if (returnString && result === void 0) {
    return "undefined";
  }
  return result;
};
const webStorage = {
  set: setWebStorage,
  get: getWebStorage,
  remove: removeWebStorage
};
exports.COOKIE_STORAGE = COOKIE_STORAGE;
exports.EXPIRE_DAY = EXPIRE_DAY;
exports.EXPIRE_MONTH = EXPIRE_MONTH;
exports.EXPIRE_YEAR = EXPIRE_YEAR;
exports.LOCAL_STORAGE = LOCAL_STORAGE;
exports.SESSION_STORAGE = SESSION_STORAGE;
exports.STATE_MANAGEMENT = STATE_MANAGEMENT;
exports.STATE_MANAGEMENT_API_HOST = STATE_MANAGEMENT_API_HOST;
exports.decodeStorage = decodeStorage;
exports.getCookieString = getCookieString;
exports.getExpirationDate = getExpirationDate;
exports.webStorage = webStorage;
